import { render, staticRenderFns } from "./Pointer_Edit.vue?vue&type=template&id=251083c1&"
import script from "./Pointer_Edit.vue?vue&type=script&lang=js&"
export * from "./Pointer_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports